<header class="app-header">
  <img class="app-header__logo" src="ServiceAgent_logo_H@4x.png" alt="myDMGMORI" />
  @if (switcherEnabled) {
  <app-language-switcher class="app-header__language" />
  }
</header>
